import VDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import { definePlugin } from '/@/app'

export default definePlugin(({ app }) => {
  app.component('VDatePicker', VDatePicker)
})
